export const DashboardRoutes = { path: 'dashboard/*', lazy: () => import('../pages/dashboard') };
